import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';

export class CreateTopicalTreatmentDto {
  @IsOptional()
  @IsString()
  otherTopicalTreatment?: string;

  @IsOptional()
  @IsBoolean()
  hasFollowUp?: boolean;

  @IsOptional()
  @IsNumber()
  followUpWeeks?: number;
}

export class UpdateTopicalTreatmentDto extends CreateTopicalTreatmentDto {}

export class TopicalTreatmentDto
  extends CreateTopicalTreatmentDto
  implements BaseDto
{
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  created?: string;
  updated?: string;
  deleted?: string;
}
